// Utility functions for generating sample data

import {
  SAMPLE_ROUTES,
  SAMPLE_TRIPS,
  SAMPLE_LICENSES,
  SAMPLE_DRIVERS,
  SAMPLE_BUS_STOPS,
} from '../constants';

/**
 * Generate sample bus data for the past N days
 */
export const generateSampleData = (days = 30) => {
  const sampleData = [];

  for (let i = days - 1; i >= 0; i--) {
    const date = new Date();
    date.setDate(date.getDate() - i);
    const dateString = date.toISOString().split('T')[0];

    // Generate 2-4 records per day
    const recordsPerDay = Math.floor(Math.random() * 3) + 2;

    for (let j = 0; j < recordsPerDay; j++) {
      const routeIndex = Math.floor(Math.random() * SAMPLE_ROUTES.length);
      const isWeekend = date.getDay() === 0 || date.getDay() === 6;
      const isRushHour = j === 0 || j === recordsPerDay - 1;

      // Adjust passenger numbers based on day type and time
      let basePassengers = 15 + Math.floor(Math.random() * 20);
      if (isWeekend) basePassengers *= 0.7;
      if (isRushHour) basePassengers *= 1.4;

      const tickets = Math.floor(basePassengers * (0.6 + Math.random() * 0.3));
      const monthlyPass = Math.floor(basePassengers * (0.2 + Math.random() * 0.2));
      const tripCount = Math.floor(Math.random() * 3) + 1;

      // Generate bus stops data
      const selectedBusStops = [];
      const numStops = Math.floor(Math.random() * 3) + 1;
      const shuffledStops = [...SAMPLE_BUS_STOPS].sort(() => 0.5 - Math.random());

      for (let k = 0; k < numStops; k++) {
        const stop = shuffledStops[k];
        const passengerVariation = Math.floor(Math.random() * stop.passengers.length);
        let stopPassengers = stop.passengers[passengerVariation];

        if (isWeekend) stopPassengers = Math.floor(stopPassengers * 0.7);
        if (isRushHour) stopPassengers = Math.floor(stopPassengers * 1.3);

        selectedBusStops.push({
          name: stop.name,
          passengers: Math.max(1, stopPassengers + Math.floor(Math.random() * 10) - 5),
        });
      }

      sampleData.push({
        id: Date.now() + Math.random(),
        date: dateString,
        route: SAMPLE_ROUTES[routeIndex],
        trip: SAMPLE_TRIPS[Math.floor(Math.random() * SAMPLE_TRIPS.length)],
        license: SAMPLE_LICENSES[routeIndex],
        driver: SAMPLE_DRIVERS[routeIndex],
        tickets: Math.max(0, tickets),
        monthlyPass: Math.max(0, monthlyPass),
        tripCount: tripCount,
        busStops: selectedBusStops,
      });
    }
  }

  return sampleData;
};

/**
 * Check if sample data should be loaded
 */
export const shouldLoadSampleData = (existingData) => {
  return !existingData || existingData.length === 0;
};
